import "./personal-info-agree-trans.css";

const PersonalInfo = () => {
  return (
    <div className="document_area">
      <span className="document_area_title">Согласие на обработку персональных данных, разрешенных для передачи</span>
      <span>
        Пользователи, которые используют сервисы Сайта, включая, но не ограничиваясь, веб-сайтом и другими цифровыми
        платформами, руководствуясь статьей 10.1 Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных»
        предоставляют Индивидуальному предпринимателю Байкину О.Н. ИНН 503820178872, ОГРНИП 326508100513422 от
        01.09.2026 года (далее — оператор), находящемуся по адресу: Центральный, д. 7, кв./оф. 40, Московская область,
        р-н Пушкино, г. Ивантеевка, baikin_98@mail.ru, согласие на обработку персональных данных, разрешенных субъектом
        персональных данных для распространения (далее — согласие).
      </span>
      <span>
        Оператор вправе осуществлять обработку предоставляемых персональных данных, разрешенных субъектом персональных
        данных для распространения:
      </span>
      <span>Перечень персональных данных:</span>
      <span style={{lineHeight: "25px"}}>
        {"- VIN номер автомобиля, марка и модель автомобиля"}
        <br />
        {"- государственный регистрационный знак автомобиля"}
        <br />
        {"- пробег автомобиля"}
        <br />
        {"- фамилия"}
        <br />
        {"- имя"}
        <br />
        {"- отчество (при наличии)"}
        <br />
        {"- год рождения"}
        <br />
        {"- месяц рождения"}
        <br />
        {"- дата (день) рождения"}
        <br />
        {"- гражданство"}
        <br />
        {"- адрес регистрации и фактического проживания, если отличается от адреса регистрации"}
        <br />
        {
          "- данные документа, удостоверяющего личность (серия, номер паспорта, дата и кем выдан паспорт, код подразделения)"
        }
        <br />
        {
          "- данные, которые автоматически передаются сервисам Сайта в процессе их использования с помощью установленного на устройстве Пользователя программного обеспечения, в том числе IP-адрес"
        }
        <br />
        {"- данные файлов cookie"}
        <br />
        {
          "- информация о браузере Пользователя (или иной программе, с помощью которой осуществляется доступ к сервисам)"
        }
        <br />
        {"- технические характеристики оборудования и программного обеспечения, используемых Пользователем"}
        <br />
        {"- дата и время доступа к сервисам, адреса запрашиваемых страниц и иная подобная информация"}
        <br />
        {"- номер телефона"}
        <br />
        {"- адрес электронной почты"}
        <br />
        {"- сведения о приобретённых или заказанных услугах и товарах"}
        <br />
        {
          "- статус взаимодействия (в том числе: произведена ли оплата, подобран ли автомобиль, совершена ли покупка, отказался ли клиент от сделки и иные статусы)."
        }
      </span>
      <span>
        {
          "Целью обработки персональных данных является надлежащее выполнение оператором своих обязательств в рамках хозяйственной деятельности, оказании услуг и гражданско-правовых отношений, вытекающих из договоров, федеральных законов, иных правовых актов, в том числе актов федеральных органов исполнительной власти, Банка России, а также из соглашений с контрагентами."
        }
        <br /><br />

        {
          "Оператор вправе передавать Данные партнёрским организациям (включая банки и иные кредитные учреждения) исключительно для целей взаимодействия по исполнению договорных и партнёрских обязательств, отчётности по статусам сделок, предоставления Пользователю информации и улучшения качества обслуживания."
        }
        <br /><br />

        {
          "Передача Данных осуществляется по защищённым каналам связи с соблюдением мер по обеспечению конфиденциальности и безопасности информации."
        }
        <br /><br />

        {
          "Партнёрские организации, получающие Данные, обязаны обеспечивать их конфиденциальность, использовать только для целей, указанных в настоящем согласии, и не передавать третьим лицам без отдельного согласия субъекта данных."
        }
        <br /><br />

        {
          "Условия, при которых полученные персональные данные могут передаваться оператором, осуществляющим обработку персональных данных, только по его внутренней сети, обеспечивающей доступ к информации лишь для строго определенных сотрудников, либо с использованием информационно-телекоммуникационных сетей, либо без передачи полученных персональных данных, регламентируются законодательством и внутренними документами оператора."
        }
        <br /><br />

        {
          "Обработка и хранение Данных осуществляется с использованием автоматизированных и неавтоматизированных средств с соблюдением требований законодательства Российской Федерации."
        }
        <br /><br />

        {
          "Оператор и его партнёры принимают все необходимые организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения и иных неправомерных действий."
        }
        <br /><br />

        {
          "В отношении персональной информации Пользователя сохраняется ее конфиденциальность, кроме случаев добровольного предоставления Пользователем информации о себе для общего доступа неограниченному кругу лиц. При использовании отдельных сервисов Пользователь соглашается с тем, что определенная часть его персональной информации становится общедоступной, а именно информация, отмеченная в таблице значком *."
        }
        <br /><br />

        {
          "Согласие действует с момента предоставления его оператору в течение неопределенного срока (или до достижения целей обработки персональных данных) и может быть отозвано путем направления оператору заявления в свободной письменной форме об отзыве согласия на адрес электронной почты: baikin_98@mail.ru, при этом оператор прекращает обработку персональных данных и уничтожает их, за исключением персональных данных, включенных в документы, обязанность по хранению которых прямо предусмотрена законодательством и внутренними документами оператора."
        }
        <br /><br />

        {
          "Хранение таких персональных данных осуществляется оператором в течение срока, установленного законодательством и внутренними документами оператора."
        }
        <br /><br />

        {
          "В случае отзыва настоящего согласия персональные данные, включенные в документы, образующиеся в деятельности оператора, в том числе во внутренние документы оператора в период действия согласия, могут передаваться третьим лицам в объеме и случаях, указанных в настоящем согласии."
        }
        <br /><br />

        {
          "Настоящее согласие считается данным с момента его подтверждения (в том числе путём проставления отметки в форме на сайте или подписания бумажного экземпляра) и действует до его отзыва."
        }
        <br /><br />

        {
          "Оператор гарантирует, что обработка персональных данных будет осуществляться строго в соответствии с действующим законодательством Российской Федерации."
        }
      </span>
    </div>
  );
};

export default PersonalInfo;
